import React from 'react';
import styles from './Spinner.less';

const DEFAULT_DIMENSION = 66;
const MIN_DIMENSION = 36;
const MAX_DIMENSION_COEF = 0.8;

export default class extends React.Component {
    state = {
        dimension: DEFAULT_DIMENSION
    };

    componentDidMount() {
        $(window).on('resize', this._fixDimensionIfNeeded);
        this._fixDimensionIfNeeded();
    }

    componentWillUnmount() {
        $(window).off('resize', this._fixDimensionIfNeeded);
    }

    render() {
        const { dimension } = this.state;
        return (
            <svg className={styles.spinner} width={dimension} height={dimension} viewBox="0 0 66 66">
                <circle className={styles.bg} fill="none" strokeWidth="4" cx="33" cy="33" r="31"></circle>
                <circle className={styles.path} fill="none" strokeWidth="4" strokeLinecap="round" cx="33" cy="33" r="31"></circle>
            </svg>
        );
    }

    _fixDimensionIfNeeded = () => {
        const { dimension } = this.state;
        const wHeight = $(window).outerHeight();
        const wWidth = $(window).outerWidth();
        const min = Math.min(wHeight, wWidth);
        const maxDimension = min * MAX_DIMENSION_COEF;
        let newDimension = null;

        if (maxDimension < dimension) {
            newDimension = maxDimension;
        } else if (dimension !== DEFAULT_DIMENSION) {
            newDimension = DEFAULT_DIMENSION;
        }

        if (newDimension) {
            newDimension = Math.min(newDimension, MIN_DIMENSION);
            this.setState({dimension: newDimension});
        }
    };
}
